import React from 'react';

import PropTypes from 'prop-types';
const PromoCode = ({promo_code, intl, is_link_promo_code, redirect_link}) => {

	const isRefLink = /^(http|https)(:\/\/)([a-zA-Z0-9])/.test(redirect_link);
	return <div className="promocode-container">
		<div>
			<div
				className="black promo__redirect"
				onMouseEnter={() => window.navigator.clipboard &&
					window.navigator.clipboard.writeText(promo_code).then(() => {}, () => {})}
			>
				<div className="top__promo">
					<span className="code">
						{ intl( !is_link_promo_code ? 'Промокод ' : 'Веб-сайт') + ':  '}
					</span>
					{`${promo_code}`}
				</div>
				<div className="bottom__promo">
					<span className="code">{intl('Перейти')}{': '}</span>
					<a
						className="promo__link"
						target="_blank"
						href={!isRefLink && is_link_promo_code ? `//${redirect_link}` : redirect_link }
					>
					</a>
				</div>
			</div>
		</div>
	</div>;
};

PromoCode.propTypes = {
	promo_code: PropTypes.string,
	is_link_promo_code: PropTypes.bool,
	redirect_link: PropTypes.string,
	intl: PropTypes.func
};

export default PromoCode;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/discounts/components/promo-code.js